import './footer.css';
import peopleImg from '../../assets/img/jpg/people.jpg';
import logoWhite from '../../assets/img/png/logo_white.png';
import { useState } from 'react';
import { useLang } from '../../context/LangContext';
import { BarLoader } from '../BarLoader/BarLoader';
import { useServer } from '../../context/serverContext';
import { endpoints } from '../../env';

export function Footer() {
    const { lang } = useLang();
    const { postRequest } = useServer();

    //STATES
    const [errorMsg, setErrorMsg] = useState("");
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const submitMessage = () => {
        if (loading) {
            return;
        }

        setLoading(true);
        setErrorMsg("");

        let data = {
            name: name,
            email: email,
            message: message,
        }

        postRequest(endpoints.messageSend, data, (res) => {
            setLoading(false);
            if (res[0]) {
                res = res[1];
                if (res.success) {
                    setName("");
                    setEmail("");
                    setMessage("");
                    setErrorMsg(lang === "en" ? "Message sent": "Mensaje enviado");
                } else {
                    setErrorMsg(lang === "en" ? "All fields are required" : "Todos los campos son requeridos");
                }
            } else {
                setErrorMsg(lang === "en" ? "Server error, please try again in a bit": "Error del servidor, intenta de nuevo en un momento");
            }
        });
    }

    return (
        <>
           
            <footer>
          
                <div className='content'>
                    <h2><span>
                        { lang === "en" ? "MORE THAN 10 MILLION LIVES TRANSFORMED" : "MÁS DE 10 MILLONES DE VIDAS TRANSFORMADAS." }
                        
                        </span>
                        <br />
                        <br />
                        { lang === "en" ? "CONTACT US!" : "¡CONTÁCTANOS!" }
                    </h2>
                    <input type='text' placeholder={lang === "en" ? "Name" : "Nombre"} value={name} onChange={(e) => setName(e.target.value)} />
                    <input type='text' placeholder={lang === "en" ? "Email" : "Correo"} value={email} onChange={(e) => setEmail(e.target.value)} />
                    <textarea placeholder={lang === "en" ? "Message" : "Mensaje"} value={message} onChange={(e) => setMessage(e.target.value)}>

                    </textarea>
                    {errorMsg !== "" &&
                        (
                            <div className='error_msg'>
                                {errorMsg}
                            </div>
                        )
                    }
                    {loading && 
                        (
                            <div className='loader'>
                                <BarLoader />
                            </div>
                        )
                    }
                    <button disabled={loading} onClick={submitMessage}>
                        { lang === "en" ? "SEND" : "ENVIAR" }
                    </button>
                </div>
                <div className='media'>
                    <div className='img'>
                        <img src={peopleImg} alt='' />
                    </div>
                </div>
            </footer>
            <div className='section-info-footer'>
                <div>
                    <img className='section-info-footer-logo' src={logoWhite} alt='' />
                    <div className='social_footer'>
                        <a href='https://www.facebook.com/john.hanley.phd/' target='_blank' rel='noreferrer'>
                            <i className="fa-brands fa-facebook-f"></i>
                        </a>
                        <a href='https://www.instagram.com/quantumhanley/' target='_blank' rel='noreferrer'>
                            <i className="fa-brands fa-instagram"></i>
                        </a>
                        <a href='https://twitter.com/quantumhanley' target='_blank' rel='noreferrer'>
                            <i className="fa-brands fa-x-twitter"></i>
                        </a>
                        <a href='https://www.youtube.com/channel/UC42bwsFlp2_PL-plx--i61g' target='_blank' rel='noreferrer'>
                            <i className="fa-brands fa-youtube"></i>
                        </a>
                        <a href='https://www.linkedin.com/company/quantumhanley111' target='_blank' rel='noreferrer'>
                            <i className="fa-brands fa-linkedin-in"></i>
                        </a>
                        <a href='https://www.google.com/search?q=john+hanley+phd&rlz=1C1ONGR_esCO998CO998&oq=&gs_lcrp=EgZjaHJvbWUqBggBEEUYOzIGCAAQRRg5MgYIARBFGDsyBggCECMYJzIHCAMQLhiABDIHCAQQLhiABDIHCAUQABiABDIHCAYQLhiABDIHCAcQLhiABDIJCAgQABgKGIAEMgcICRAuGIAE0gEIMTk1MGowajeoAgCwAgA&sourceid=chrome&ie=UTF-8' target='_blank' rel='noreferrer'>
                            <i className="fa-solid fa-store"></i>
                        </a>
                    </div>
                </div>
                <div>
                    <a className='footer-a' href='tel:+52 449 113 90 08'>
                        <i aria-hidden="true" className="fas fa-phone-alt"></i>  +52 (449) 113-9008 </a>
                    <a className='footer-a' href='#'>
                        <i aria-hidden="true" className="fas fa-map-marker-alt"></i>  México, Tijuana, Los Ángeles y Nueva York </a>
                    <a className='footer-a' href='mailto:transformacion@johnhanleyphd.com'>
                        <i aria-hidden="true" className="fas fa-envelope"></i>  transformacion@johnhanleyphd.com </a>
                </div>
            </div>
            <div className='poweredby'>
                <a href={lang === "en" ? "https://johnhanleyphdus.com/" : "https://www.johnhanleyphd.com/"}>
                    © 2023 John Hanley PhD
                </a>
                <span>
                    |
                </span>
                <a href='https://ajcreativestudios.com/'>
                    AJ Creative Studios
                </a>
            </div>
        </>
    );
}